@if (!planList) {
  <skeleton />
}
@if (planList) {
  <section>
    <custom-select [label]="'order-product-discontinuations.supersede-product-plan' | translate"
      [allowAutoFocus]="false"
      [selectList]="planList"
      [value]="discontinuation.productPlan"
      (valueChange)="selectPlan($event)"
      [autoSort]="true"
    [required]="true"></custom-select>
    <custom-input [label]="'order-product-discontinuations.adjustment-amount' | translate"
      [inputType]="inputType.Currency"
      [required]="true"
      [(value)]="discontinuation.adjustmentAmount"
      [customValidationMessage]="'order-product-discontinuations.too-high-adjustment-amount' | translate"
    [customValidState]="discontinuation.adjustmentAmount >= 0 && discontinuation.adjustmentAmount <= maxAdjustmentValue"></custom-input>
    <custom-input [label]="'order-product-discontinuations.remaining-amount' | translate"
      [inputType]="inputType.Currency"
      [disabled]="true"
      [(value)]="discontinuation.remainingAmount"></custom-input>
  </section>
  <section>
    <ng-content />
  </section>
}
